import './plafond-list.scss';

/**
 * version    1.0
 * class      <type> (plafond-list)
 * classdesc  Component that manage plafond-list
 */
export class PlafondList {}
